// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PEdUM","colBig":"styles_colBig__14bvw","colSmall":"styles_colSmall__3i2aL","shopifyNameWrapper":"styles_shopifyNameWrapper__H7hB3"};